'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 10,
    bottom: 50,
    left: 80,
    right: 20
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 8,
    yAxisShift: 12,
    yAxisLabelShift: 70
  };
};
module.exports = Params;